/* SPEC-146 — the "Decisions (N)" top-bar pill. The persistent re-entry point to the
 * Rulings Desk. Rendered only when the user has pending decisions (so the other execs,
 * who are never in a card's audience, see nothing). Sits next to the Walk-through
 * button. SPEC-462: on desktop the left rail's Decisions button replaced this pill; the
 * pill now renders on MOBILE only, where there is no rail. Both carry the `rulings-pill`
 * tour anchor, and the tour engine spotlights whichever one is actually displayed. */
import { Gavel } from 'lucide-react';
import { useRulings } from './RulingsProvider';

export function RulingsPill() {
  const { count, openDesk } = useRulings();
  if (count < 1) return null;
  return (
    <button
      data-tour="rulings-pill"
      onClick={openDesk}
      className="flex items-center gap-1.5 px-2.5 py-2 rounded-lg text-amber-400 bg-amber-500/10 border border-amber-500/25 hover:bg-amber-500/20 transition-colors"
      title={`${count} decision${count === 1 ? '' : 's'} waiting for your steer`}
    >
      <Gavel className="w-4 h-4" />
      <span className="text-xs font-semibold">
        Decisions <span className="tabular-nums">({count})</span>
      </span>
    </button>
  );
}
